// extracted by mini-css-extract-plugin
export default {"subheader":"Subheader_subheader__hVa8J"};